import UserDeleteAccountForm from './UserDeleteAccountForm'

export default UserDeleteAccountForm
